export default {
  author: "作者",
  status: "状态",
  category: "分类",
  updateTime: "最近更新",
  views: "阅读量",
  rating: "评分",
  tags: "标签",
  description: "作品简介",
  chapters: "章节列表",
  chapterCount: "共 {{count}} 话",
  startReading: "开始阅读",
  continueReading: "继续阅读",
  relatedRecommend: "相关推荐",
  noDescription: "暂无简介",
  completed: "完结",
  ongoing: "连载中",
};